export default {
  INDEX: '/',
  FORGOT_PASSWORD: '/forgotPassword',
  RESET_PASSWORD: '/resetPassword',
  ERROR_PAGE: '/error',
};
